export enum TransactionType {
  TASK_TEMPLATE = 'TASK_TEMPLATE',
  WORKFLOW_EVENT = 'WORKFLOW_EVENT',
  MED_REVIEW = 'MED_REVIEW',
  FORM = 'FORM',
  DOCUMENT_CATEGORY = 'DOCUMENT_CATEGORY',
  NOTIFICATION = 'NOTIFICATION',
  ACTIVITY_TEMPLATE = 'ACTIVITY_TEMPLATE',
  ACTIVITY_TEMPLATE_STEP = 'ACTIVITY_TEMPLATE_STEP',
}
